<template>
  <el-table :data="contentThreads" size="mini">
    <el-table-column prop="name" label="Topic">
      <template slot-scope="scope">
        <span
          :style="{'color': generateTitleColor(scope.row.name)}"
          class="content-threads-topic-name">{{scope.row.name}}
        </span>
      </template>
    </el-table-column>
    <!-- <el-table-column label="Impactors">
      <template slot-scope="scope">
        <el-tooltip content="We are currently working on this feature">
          <span :style="{'color': generateTitleColor(scope.row.name)}">
            coming soon
          </span>
        </el-tooltip>
      </template>
    </el-table-column> -->
    <!-- <el-table-column label="Sentiment">
      <template slot-scope="scope">
        <el-tooltip content="We are currently working on this feature">
          <span :style="{'color': generateTitleColor(scope.row.name)}">
            coming soon
          </span>
        </el-tooltip>
      </template>
    </el-table-column> -->
    <!-- <el-table-column prop="impactors" label="Impactors" width="90" />
    <el-table-column prop="sentiment" label="Sentiment" width="90" /> -->
  </el-table>
</template>

<script>
import colorMixin from '@/mixins/colors';

export default {
  name: 'ContentThreadsTable',

  mixins: [colorMixin],

  props: {
    data: {
      type: Array,
      required: true,
    },
    limit: {
      type: Number,
      required: false,
    },
  },

  computed: {
    contentThreads() {
      return this.limit ? this.data.slice(0, this.limit) : this.data;
    },
  },
};
</script>

<style lang="scss" scoped>
.content-threads-topic-name {
  font-weight: bold;
}

.el-table {
  padding-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// ContentThreadsTable.vue?1f3f92f2